import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitLead = async (data) => {
  const res = await axios.post(`${API}/leads`, data);
  return res.data;
};

export const fetchLeads = async (token) => {
  const res = await axios.get(`${API}/leads`, { headers: { "X-Admin-Token": token } });
  return res.data;
};

export const fetchLeadStats = async (token) => {
  const res = await axios.get(`${API}/leads/stats`, { headers: { "X-Admin-Token": token } });
  return res.data;
};

export const updateLeadStatus = async (token, id, status) => {
  const res = await axios.patch(`${API}/leads/${id}/status?status=${status}`, {}, { headers: { "X-Admin-Token": token } });
  return res.data;
};
